import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import { APPLICATION_CONTEXTS } from '../../constants';
import ImageBackground from '../common/imageBackground';
import ImageHeader from '../common/imageHeader';
import NavigationBar from '../common/navigationBar';

class Service1278 extends Component {
  /**************
   * Properties *
   **************/
  header = {
    id: 'header',
    src: require('./images/1278_elements.png')
  };
  navigationBar = {
    mainMenu: false,
    back: false,
    backRoute: '/main_menu'
  };

  handleOnClick = () => {
    if (this.props.context === APPLICATION_CONTEXTS.SERVICES) {
      this.props.history.push('/main_menu');
    }
  };

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1278">
        <Switch>
          <Route
            path="/ipg"
            render={routeProps => (
              <div onClick={this.handleOnClick}>
                <ImageBackground id="background" isIPG={true} />
                <ImageHeader {...this.header} />
                <NavigationBar {...this.navigationBar} />
              </div>
            )}
          />
        </Switch>
      </div>
    );
  }
}

const ConnectedService1278 = connect(
  state => ({
    context: state.application.currentContext
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(Service1278);

export default withRouter(ConnectedService1278);
